export const resetNavBarState = () => {
    localStorage.removeItem("tabs");
    localStorage.removeItem("currentPage");
    localStorage.removeItem("currentPageLink");
    localStorage.removeItem("subMenuOpen");
    localStorage.removeItem("sidebarOpen");
};